import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Button } from './button.js';
import { Input } from './input.js';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './dialog.js';
// A guarded confirmation dialog: the action button stays disabled until the user
// types the exact `confirmPhrase` (typically the entity's name). Used for the
// destructive lifecycle actions (suspend / archive) where a stray click would
// log people out, so we make the intent explicit.
export function ConfirmDestructive({ open, onOpenChange, title, description, confirmPhrase, confirmLabel = 'Confirm', variant = 'destructive', onConfirm, }) {
    const [text, setText] = useState('');
    const [busy, setBusy] = useState(false);
    // Clear the typed phrase whenever the dialog opens, so a prior attempt's text
    // never pre-arms the button.
    useEffect(() => { if (open)
        setText(''); }, [open]);
    const matches = text.trim() === confirmPhrase;
    async function go() {
        if (!matches || busy)
            return;
        setBusy(true);
        try {
            await onConfirm();
            onOpenChange(false);
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsx(Dialog, { open: open, onOpenChange: (o) => { if (!busy)
            onOpenChange(o); }, children: _jsxs(DialogContent, { children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: title }), _jsx(DialogDescription, { children: description })] }), _jsxs("div", { className: "space-y-3", children: [_jsxs("p", { className: "text-sm text-muted-foreground", children: ["Type ", _jsx("span", { className: "font-mono font-medium text-foreground", children: confirmPhrase }), " to confirm."] }), _jsx(Input, { value: text, autoFocus: true, placeholder: confirmPhrase, onChange: (e) => setText(e.target.value), onKeyDown: (e) => { if (e.key === 'Enter')
                                void go(); } }), _jsxs("div", { className: "flex justify-end gap-2 pt-1", children: [_jsx(Button, { type: "button", variant: "ghost", disabled: busy, onClick: () => onOpenChange(false), children: "Cancel" }), _jsx(Button, { type: "button", variant: variant, disabled: !matches || busy, onClick: () => void go(), children: busy ? 'Working…' : confirmLabel })] })] })] }) }));
}
